import { LOGOUT_CALLBACK_ROUTE } from "../constants";

export const onRedirectCallback = (appState) => {
  window.location.href = appState?.returnTo || "/";
};

export const getAuth0ReturnToRoute = ({
  baseRoute = window.location.pathname,
  includeOrigin = false,
  params = {},
  fullUrl = false,
}) => {
  const url = new URL(baseRoute, window.location.origin);

  if (includeOrigin) {
    url.searchParams.append("origin", window.location.pathname);
  }

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  return fullUrl ? url.href : url.pathname + url.search;
};

export const logoutUrl = () =>
  getAuth0ReturnToRoute({
    baseRoute: window.location.origin + LOGOUT_CALLBACK_ROUTE,
    params: { returnTo: window.location.pathname + window.location.search },
    fullUrl: true,
  });
